import React, { Suspense, lazy } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { ReallocateProvider } from "./context/ReallocateContext";
import { AutoAllocateProvider } from "./context/AutoAllocateContext";
import { ManualSOUpdateProvider } from "./context/ManualSOUpdateContext";
import { DebitCreditNoteProvider } from "./context/DebitCreditNoteContext";
import Loader from "./Components/Loader";
import CreateSOOrder from "./Pages/ManualSOOrder/Index";
import ViewCustomer from "./Pages/ViewCustomer";
import NewCustomer from "./Pages/NewCustomer";
import GRN from "./Pages/GRN/Index";
import ViewGRN from "./Pages/GRN/ViewGRN";
import StockInHand from "./Pages/Reports/Stock/StockInHand";
import SupplierMasterView from "./Pages/SupplierMaster/Index";
import SupplierMasterNew from "./Pages/SupplierMaster/NewSupplier";
import DSRDealerMapping from "./Pages/DSRDealerMapping/Index";
import PaytermLimitUpload from "./Pages/PaytermLimitUpload/Index";
import WarehouseMaster from "./Pages/WarehouseMaster/Index";
// import Print from "./Pages/InvoicePrint/NewPrintInvoice"
import WarehouseMasterNew from "./Pages/WarehouseMaster/NewWarehouse";
import PaymentAccountDefinition from "./Pages/PaymentAccountDefinition/Index";
import SearchModal from "./Pages/SearchModal/Index";
import EmployeeTable from "./Pages/EmployeeMaster/EmployeeTable";
import ProductMaster from "./Pages/ProductMaster/Index";
import ProductPages from "./Pages/ProductMaster/ProductPages";
import SalesReturn from "./Pages/SalesReturn/Index";
import AllWriteOffRecords from "./Pages/WriteOff/AllWriteOffRecords";
import WriteOffDetails from "./Pages/WriteOff/WriteOffDetails";
import OutstandingAdjustment from "./Pages/WriteOff/OutstandingAdjustment";
import AllSalesReturnTable from "./Pages/SalesReturn/AllSalesReturnTable";
import NewEmployee from "./Pages/EmployeeMaster/Index";
import DeliveryChallan from "./Pages/DeliveryChallan/Index";
import GRNnonInv from "./Pages/GRNnonINV/GRNnonInv";
import ViewGRNnonINV from "./Pages/GRNnonINV/ViewGRNnonINV"; 
import { DeliveryChallanProvider } from "./context/DeliveryChallanContext";
import { ReceiptsProvider } from "./context/ReceiptsContext";
import { ForgotPasswordProvider } from "./context/ForgotPasswordContext";

import { EmployeeMasterProvider } from "./context/EmployeeMasterContext";
import { StockAdjustmentProvider } from "./context/StockAdjustmentContext";
import StockTable from "./Pages/StockAdjustment/StockTable";
import NewStock from "./Pages/StockAdjustment/NewStock";
import { WareHouseMasterProvider } from "./context/WareHouseContext";
import { FreeInvoiceProvider } from "./context/FreeInvoiceContext";
import UserDetails from "./Pages/UserManagement/User/UserDetails";
import User from "./Pages/UserManagement/User/User";
import Master from "./Pages/UserManagement/Parameter_Settings/Master";
import Transaction from "./Pages/UserManagement/Parameter_Settings/Transaction";
import FieldLevelSettings from "./Pages/UserManagement/User_Groups/FieldLevelSettings";
import UserGroups from "./Pages/UserManagement/User_Groups/UserGroups";
import UserGroupsDetails from "./Pages/UserManagement/User_Groups/UserGroupsDetails";
import AllReceiptsRecords from "./Pages/Receipts/AllReceiptsRecords";
import NewReceipt from "./Pages/Receipts/NewReceipt";
import StockInHandNI from "./Pages/Reports/Stock/StockInhandNI";
import GrnDataExcel from "./Pages/Reports/GrnDataExcel";
import DeliveryChallanExcel from "./Pages/Reports/Sales/DeliveryChallanExcel";
import LoadingReport from "./Pages/Reports/Sales/LoadingReport";
import EInvoicingDataDownload from "./Pages/Reports/Sales/EInvoicingDataDownload";
import InvoiceDataExcel from "./Pages/Reports/Sales/InvoiceDataExcel";
import GRNDiscountDatatoExcel from "./Pages/Reports/Purchase/GRNDiscountDatatoExcel";
import NonInventoryGRNtoExcel from "./Pages/Reports/Purchase/NonInventoryGRNtoExcel";
import StockMonthlyDetailReport from "./Pages/Reports/Stock/StockMonthlyDetailReport";
import StockDailyDetailReport from "./Pages/Reports/Stock/StockDailyDetailReport";
import StockCard from "./Pages/Reports/Stock/StockCard";
import StockInHandNonInventory from "./Pages/Reports/Stock/StockInHandNonInventory";
import ReceiptMadeWithinPeriod from "./Pages/Reports/Credit_Management_Reports/ReceiptMadeWithinPeriod";
import LedgerReport from "./Pages/Reports/Credit_Management_Reports/LedgerReport";
import StatementOfAccounts from "./Pages/Reports/Credit_Management_Reports/StatementOfAccounts";
import SalesAgeingReport from "./Pages/Reports/Credit_Management_Reports/SalesAgeingReport";
import StockAdjustmentReport from "./Pages/Reports/Stock/StockAdjusmentReport";
import Help from "./Pages/Help/Help";
import Details from "./Pages/DocumentAdjustment/Details";
import AllRecords from "./Pages/DocumentAdjustment/AllRecords";
import AllPurchaseReturnRecords from "./Pages/PurchaseReturn/AllPurchaseReturnRecords";
import PurchaseReturnDetails from "./Pages/PurchaseReturn/PurchaseReturnDetails";
import Maintenance from "./Pages/UnderMaintenance/Maintenance";
import AdvanceAdjustmentAllRecords from "./Pages/CustomerAdvanceAdjustment/AdvanceAdjustmentAllRecords";
import AdvanceAdjustmentDetails from "./Pages/CustomerAdvanceAdjustment/AdvanceAdjustmentDetails";
import { PurchaseReturnProvider } from "./context/PurchaseReturnContext";
import { WriteOffProvider } from "./context/WriteOffContext";
import OpenSalesOrder from "./Pages/Reports/Sales/OpenSalesOrder";
import GstReportExcel from "./Pages/Reports/Others/GstReportExcel";
import NonInventoryReport from "./Pages/Reports/Others/NonInventoryReport";
import DistributorSIPPayoutReport from "./Pages/Reports/DistributorSIPPayoutReport";
import CustomerMetricReport from "./Pages/Reports/Others/CustomerMetricReport";
import CustomerOutstandingStatus from "./Pages/Reports/Credit_Management_Reports/CustomerOutstandingStatus";
import CreditNoteAdjustment from "./Pages/Reports/Credit_Management_Reports/CreditNoteAdjustment";
import CustomerCreditNote from "./Pages/Reports/Credit_Management_Reports/CustomerCreditNote";
import CustomerDebitNote from "./Pages/Reports/Credit_Management_Reports/CustomerDebitNote";
import AnnexureAllRecords from "./Pages/InvoiceAnnexurePrint/AnnexureAllRecords";
import NonInventory from "./Pages/Reports/Others/NonInventory";
import PriceList from "./Pages/Reports/PriceList";
import AllCreationRecords from "./Pages/CreditNoteCreation/AllCreationRecords";
import PDAReceiptCreation from "./Pages/PDAReceipts/PDAReceiptCreation";
import PDAReceipts from "./Pages/PDAReceipts/PDAReceipts";
import DefaultSettings from "./Pages/UserManagement/DefaultSettings/DefaultSettings";
import SchemeShortFall from "./Pages/Reports/SchemeShortFall";
import FreezedCNFOCReport from "./Pages/QRM/FreezedCNFOCReport";
import InvoiceTemplateManager from "./Pages/InvoiceTemplates/InvoiceTemplateManager";
import CreditNoteunlockAll from "./Pages/QRM/CreditNoteunlockAll";
import CreditNoteunlockAddNew from "./Pages/QRM/CreditNoteunlockAddNew";
import FocUnlockRequestAll from "./Pages/QRM/FocUnlockRequestAll";
import FocUnlockRequestAddNew from "./Pages/QRM/FocUnlockRequestAddNew";
import { CNCreationProvider } from "./context/CreditNoteCreation";
import WorkshopDiscountDefinition from "./Pages/WorkshopDiscountDefinition/Index";
import DistributorCollateralDispatchAddress from "./Pages/DistributorCollateralDispatchAddress/Index";
import BeatFrequencyPlanning from "./Pages/BeatFrequencyPlanning/Index";
import PriceVariation from "./Pages/PriceVariation/Index";
import SalesDiscountAllocationAllRecords from "./Pages/SalesDiscountAllocation/AllRecords";
import SalesDiscountAllocation from "./Pages/SalesDiscountAllocation/Index";
import DiscountDefinitionAllRecords from "./Pages/DiscountDefinition/AllRecords";
import DiscountDefinition from "./Pages/DiscountDefinition/Index";
import NewProductIntroduction from "./Pages/NewProductIntroduction/Index";
import AplusProduct from "./Pages/AplusProduct/Index";
import ABCView from "./Pages/ABCView/Index";
import StockNorm from "./Pages/StockNorm/Index";
import PurchaseOrderGeneration from "./Pages/PurchaseOrderGeneration/Index";
import OddLotConversionAllRecords from "./Pages/OddLotConversion/OddLotConversionAllRecords";
import OddLotConversion from "./Pages/OddLotConversion/Index";
import StockNormBulkUpload from "./Pages/StockNormBulkUpload/Index";
import CollateralDestroyAllRecords from "./Pages/CollateralDestroy/CollateralDestroyAllRecords";
import CollateralDestroy from "./Pages/CollateralDestroy/Index";
// import CreateChangeRequest from "./Pages/SegmentReactivationChangeRequest/CreateChangeRequest";
// import SegmentReactivationAllRecords from "./Pages/SegmentReactivationChangeRequest/SegmentReactivationAllRecords";
// const PersistLogin = lazy(() => import("./Components/PersistLogin"));
const RequireAuth = lazy(() => import("./Components/RequireAuth"));
const RequireDisclaimer = lazy(() => import("./Components/RequireDisclaimer"));
const Disclaimer = lazy(() => import("./Pages/Disclaimer/Index"));
const Dashboard = lazy(() => import("./Components/Dashboard/Index"));
const SalesOrderDetails = lazy(() => import("./Pages/SalesOrderDetails/Index"));
const SalesOrders = lazy(() => import("./Pages/SalesOrders/Index"));
const Invoice = lazy(() => import("./Pages/Invoice/Index"));
// const InvoicePrint = lazy(() => import("./Pages/InvoicePrint/Index"));
const AddEInvoice = lazy(() => import("./Pages/AddEInvoice/Index"));
const Login = lazy(() => import("./Pages/Login"));
const LoginLayout = lazy(() => import("./Layouts/LayoutLogin/LoginLayout"));
const Forget = lazy(() => import("./Pages/ForgotPassword/Index"));
const ResetPassword = lazy(() => import("./Pages/ResetPassword/Index"));
const MasterLayout = lazy(() => import("./Layouts/LayoutLogin/MasterLayout"));
const AddPaymentUPI = lazy(() => import("./Pages/AddPaymentUPI/Index"));
const DebitCreditNote = lazy(() => import("./Pages/DebitCreditNote/Index"));
import CreateChangeRequest from "./Pages/SegmentReactivationChangeRequest/CreateChangeRequest";
import SegmentReactivationAllRecords from "./Pages/SegmentReactivationChangeRequest/SegmentReactivationAllRecords";
import SalesMonthly from "./Pages/Reports/Sales/SalesMonthly";
import SalesPeriodic from "./Pages/Reports/Sales/SalesPeriodic";
import SalesPeriodicReportPDF from "./Pages/Reports/Sales/SalesPeriodicReportPDF";
import SalesDaily from "./Pages/Reports/Sales/SalesDaily";
import SalesCastrolWeekly from "./Pages/Reports/Sales/SalesCastrolWeekly";
import SalesCastrolQuarterly from "./Pages/Reports/Sales/SalesCastrolQuarterly";
import SalesComparison from "./Pages/Reports/Sales/SalesComparison";
import TaxDetails from "./Pages/Reports/Sales/TaxDetails";
import HoldProductForAutoAllocation from "./Pages/HoldProductForAutoAllocation/HoldProductForAutoAllocation";
import BulkInvoiceGeneration from "./Pages/BulkInvoiceGeneration/BulkInvoiceGeneration";
import CollateralReallocation from "./Pages/CollateralReallocation/CollateralReallocation";
import IssueLogger from "./Pages/Helpdesk/IssueLogger";
import SurveyFeedback from "./Pages/Helpdesk/SurveyFeedBack/SurveyFeedback";
import SurveyFeedbackView from "./Pages/Helpdesk/SurveyFeedBack/SurveyFeedbackView";
import ServiceInvoiceAllrecords from "./Pages/ServiceInvoice/ServiceInvoiceAllrecords";
import ServiceInvoiceDetails from "./Pages/ServiceInvoice/ServiceInvoiceDetails";
import SaleInTransit from "./Pages/SaleInTransit/SaleInTransit";
import TransferofAdjustedCNandFOC from "./Pages/TransferofCNandFOC/TransferofAdjustedCNandFOC";
import TCSApplicability from "./Pages/UserManagement/Parameter_Settings/TCSApplicability";
import AddEInvoicingItem from "./Pages/UserManagement/Parameter_Settings/AddEInvoicingItem";
import UserAddPaymentUPI from "./Pages/UserManagement/Parameter_Settings/UserAddPaymentUPI";
import BulkInvoicingApplicability from "./Pages/UserManagement/Parameter_Settings/BulkInvoicingApplicability";
import Privilage from "./Pages/UserManagement/User_Groups/Privilage";
import CouponDisbursement from "./Pages/FastScan/CouponDisbursement";
import CouponReporttoExcel from "./Pages/FastScan/CouponReporttoExcel";
import RewardsRebatebook from "./Pages/UserManagement/RewardsRebatebook";
import PaymentAllRecords from "./Pages/Payments/PaymentAllRecords";
import PaymentDetails from "./Pages/Payments/PaymentDetails";
import BankingTransactionAllRecords from "./Pages/BankingTransaction/BankingTransactionAllRecords";
import BankingTransactionDetails from "./Pages/BankingTransaction/BankingTransactionDetails";
import ViewFoc from "./Pages/FreeInvoice/ViewFOC";
import SGRBrandDataView from "./Pages/SGRBrand/SGRBrandDataView";
import SGRBrandEligibility from "./Pages/SGRBrand/SGRBrandEligibility";
import CollectionDataDownload from "./Pages/CollectionDataDownload/CollectionDataDownload";
import MultipleCreditNotePrint from "./Pages/MultipleCreditNotePrint/MultipleCreditNotePrint";
import DealerOutstandingSMS from "./Pages/DealerOutstandingSms/DealerOutstandingSMS";
import RSECustomerAllRecords from "./Pages/RSECustomer/RSECustomerAllRecords";
import RSECustomerDetails from "./Pages/RSECustomer/RSECustomerDetails";
import UrbanAlldata from "./Pages/UrbanServiceInv/UrbanAlldata";
import UrbanServiceCreat from "./Pages/UrbanServiceInv/UrbanServiceCreat";
const DebitCreditAllRecords = lazy(() =>
    import("./Pages/DebitCreditNote/DebitCreditAllRecords")
); 
const FreeInvoice = lazy(() => import("./Pages/FreeInvoice/Index"));

function App() {
    return (
        <>
            <ToastContainer />
            <Suspense fallback={<Loader />}>
                <Routes>
                    {/* <Route path="/newprint" element={<Print/>}/> */}
                    <Route path="/" element={<LoginLayout />}>
                        <Route
                            index
                            element={
                                <ForgotPasswordProvider>
                                    <Login />
                                </ForgotPasswordProvider>
                            }
                        />
                        <Route
                            path="/forget-password"
                            element={
                                <ForgotPasswordProvider>
                                    <Forget />
                                </ForgotPasswordProvider>
                            }
                        />
                    </Route>
                    {/* <Route element={<PersistLogin />}> */}
                    <Route element={<RequireAuth />}>
                        {/* Authenticated, but not yet past the disclaimer. */}
                        <Route path="/disclaimer" element={<Disclaimer />} />
                        <Route element={<RequireDisclaimer />}>
                            <Route element={<MasterLayout />}>
                                <Route
                                    path="/usermanagement/resetpassword"
                                    element={<ResetPassword />}
                                />
                                <Route
                                    path="/usermanagement/defaultsettings"
                                    element={<DefaultSettings />}
                                />
                                <Route index path="/dashboard" element={<Dashboard />} />
                                <Route
                                    path="/salesmanagement/salesorder/details"
                                    element={
                                        <AutoAllocateProvider>
                                            <ReallocateProvider>
                                                <SalesOrderDetails />
                                            </ReallocateProvider>
                                        </AutoAllocateProvider>
                                    }
                                />
                                <Route
                                    path="/salesmanagement/salesorder/manualsalesorder"
                                    element={
                                        <AutoAllocateProvider>
                                            <ReallocateProvider>
                                                <ManualSOUpdateProvider>
                                                    <CreateSOOrder />
                                                </ManualSOUpdateProvider>
                                            </ReallocateProvider>
                                        </AutoAllocateProvider>
                                    }
                                />
                                <Route
                                    path="/salesmanagement/salesorder"
                                    element={<SalesOrders />}
                                />
                                {/* <Route path="/invoice" element={<Invoice />} /> */}
                                <Route
                                    path="/salesmanagement/freeinvoice"
                                    element={
                                        <DeliveryChallanProvider>
                                            <FreeInvoiceProvider>
                                                <FreeInvoice />
                                            </FreeInvoiceProvider>
                                        </DeliveryChallanProvider>
                                    }
                                />
                                <Route
                                    path="/salesmanagement/freeinvoice/ViewFoc"
                                    element={
                                        <ViewFoc />
                                    }
                                />

                                <Route path="/add-e-invoice" element={<AddEInvoice />} />
                                <Route path="/add-payment-UPI" element={<AddPaymentUPI />} />
                                <Route path="/invoice-templates" element={<InvoiceTemplateManager />} />
                                <Route
                                    path="/masters/customermaster"
                                    element={<ViewCustomer />}
                                />
                                <Route
                                    path="/masters/customermaster/details"
                                    element={<NewCustomer />}
                                />
                                <Route
                                    path="/masters/ruralserviceexpress"
                                    element={<RSECustomerAllRecords />}
                                />
                                <Route
                                    path="/masters/ruralserviceexpress/details"
                                    element={<RSECustomerDetails />}
                                />
                                <Route
                                    path="/salesmanagement/deliverychallan"
                                    element={
                                        <DeliveryChallanProvider>
                                            <DeliveryChallan />
                                        </DeliveryChallanProvider>
                                    }
                                />

                                <Route
                                    path="/salesmanagement/invoice"
                                    element={
                                        <DeliveryChallanProvider>
                                            <Invoice />
                                        </DeliveryChallanProvider>
                                    }
                                />

                                <Route
                                    path="/inventorymanagement/stockadjustment/details"
                                    element={
                                        <StockAdjustmentProvider>
                                            <NewStock />
                                        </StockAdjustmentProvider>
                                    }
                                />
                                <Route
                                    path='/inventorymanagement/NewProductIntroduction'
                                    element={<NewProductIntroduction />}
                                />
                                <Route
                                    path='/inventorymanagement/AplusProduct'
                                    element={<AplusProduct />}
                                />
                                <Route
                                    path='/inventorymanagement/ABCView'
                                    element={<ABCView />}
                                />
                                <Route
                                    path='/inventorymanagement/StockNorm'
                                    element={<StockNorm />}
                                />
                                <Route
                                    path='/inventorymanagement/PurchaseOrderGeneration'
                                    element={<PurchaseOrderGeneration />}
                                />
                                <Route
                                    path='/inventorymanagement/OddLotConversionAllRecords'
                                    element={<OddLotConversionAllRecords />}
                                />
                                <Route
                                    path='/inventorymanagement/OddLotConversion'
                                    element={<OddLotConversion />}
                                />
                                <Route
                                    path='/inventorymanagement/StockNormBulkUpload'
                                    element={<StockNormBulkUpload />}
                                />
                                <Route
                                    path='/inventorymanagement/CollateralDestroyAllRecords'
                                    element={<CollateralDestroyAllRecords />}
                                />
                                <Route
                                    path='/inventorymanagement/CollateralDestroy'
                                    element={<CollateralDestroy />}
                                />

                                <Route
                                    path="/masters/employeemaster/details"
                                    element={
                                        <EmployeeMasterProvider>
                                            <NewEmployee />
                                        </EmployeeMasterProvider>
                                    }
                                />
                                <Route
                                    path="/masters/employeemaster"
                                    element={
                                        <EmployeeMasterProvider>
                                            <EmployeeTable />
                                        </EmployeeMasterProvider>
                                    }
                                />
                                <Route
                                    path="/masters/productmaster"
                                    element={<ProductMaster />}
                                />
                                <Route
                                    path="/masters/productmaster/details"
                                    element={<ProductPages />}
                                />
                                <Route
                                    path="/purchasemanagement/goodsreceiptnote"
                                    element={<GRN />}
                                />
                                <Route
                                    path="/reports/stock/stockinhand"
                                    element={<StockInHand />}
                                />
                                <Route path="/stockinhandnonin" element={<StockInHandNI />} />
                                <Route
                                    path="/reports/stock/stockadjustmentreport"
                                    element={<StockAdjustmentReport />}
                                />
                                <Route
                                    path="/reports/purchase/grndatatoexcel"
                                    element={<GrnDataExcel />}
                                />
                                <Route
                                    path="/salesmanagement/salesreturn"
                                    element={<SalesReturn />}
                                />
                                <Route
                                    path="/salesmanagement/holdproductforautoallocation"
                                    element={< HoldProductForAutoAllocation />}
                                />
                                <Route
                                    path="/salesmanagement/bulkinvoicegeneration"
                                    element={< BulkInvoiceGeneration />}
                                />
                                <Route
                                    path="/salesmanagement/collateralreallocation"
                                    element={< CollateralReallocation />}
                                />
                                <Route
                                    path="/salesmanagement/serviceinvoice"
                                    element={< ServiceInvoiceAllrecords />}
                                />
                                <Route
                                    path="/salesmanagement/serviceinvoice/details"
                                    element={< ServiceInvoiceDetails />}
                                />
                                <Route
                                    path="/salesmanagement/urbanserviceinvoice"
                                    element={< UrbanAlldata />}
                                />
                                <Route
                                    path="/salesmanagement/urbanserviceinvdetails"
                                    element={< UrbanServiceCreat />}
                                />
                                <Route
                                    path="/reports/others/gstreporttoexcel"
                                    element={<GstReportExcel />}
                                />
                                <Route
                                    path="/reports/others/CustomerMetricReport"
                                    element={<CustomerMetricReport />}
                                />
                                <Route
                                    path="/reports/others/NonInventoryReport"
                                    element={<NonInventoryReport />}
                                />
                                <Route
                                    path="/reports/DistributorSIPPayoutReport"
                                    element={<DistributorSIPPayoutReport />}
                                />
                                <Route
                                    path="/salesmanagement/salesreturn/details"
                                    element={<AllSalesReturnTable />}
                                />
                                <Route
                                    path="/reports/others/noninventory"
                                    element={<NonInventory />}
                                />
                                <Route
                                    path="/creditmanagement/multiplecreditnoteprint"
                                    element={<MultipleCreditNotePrint />}
                                />
                                <Route
                                    path="/creditmanagement/debitcreditnote/details"
                                    element={
                                        <DebitCreditNoteProvider>
                                            <DebitCreditNote />
                                        </DebitCreditNoteProvider>
                                    }
                                />
                                <Route
                                    path="/creditmanagement/debitcreditnote"
                                    element={
                                        <DebitCreditNoteProvider>
                                            <DebitCreditAllRecords />
                                        </DebitCreditNoteProvider>
                                    }
                                />
                                {/* <Route path="/viewgoodsreceiptnode" element={<ViewGRN />} /> */}
                                <Route
                                    path="/purchasemanagement/goodsreceiptnote/details"
                                    element={<ViewGRN />}
                                />
                                <Route
                                    path="/purchasemanagement/saleintransit"
                                    element={<SaleInTransit />}
                                />
                                <Route
                                    path="/masters/suppliermaster"
                                    element={
                                        <EmployeeMasterProvider>
                                            <SupplierMasterView />
                                        </EmployeeMasterProvider>
                                    }
                                />
                                <Route
                                    path="/masters/suppliermaster/details"
                                    element={
                                        <EmployeeMasterProvider>
                                            <SupplierMasterNew />
                                        </EmployeeMasterProvider>
                                    }
                                />
                                <Route
                                    path="/masters/sedealermapping"
                                    element={<DSRDealerMapping />}
                                />
                                <Route
                                    path="/masters/workshopdiscountdefinition"
                                    element={<WorkshopDiscountDefinition />}
                                />
                                <Route
                                    path="/masters/distributorcollateraldispatchaddress"
                                    element={
                                        <EmployeeMasterProvider>
                                            <DistributorCollateralDispatchAddress />
                                        </EmployeeMasterProvider>
                                    }
                                />
                                <Route
                                    path="/masters/pricevariation"
                                    element={<PriceVariation />}
                                />
                                <Route
                                    path="/masters/salesdiscountallocation"
                                    element={<SalesDiscountAllocationAllRecords />}
                                />
                                <Route
                                    path='/masters/salesdiscountallocation/details'
                                    element={<SalesDiscountAllocation />}
                                />
                                <Route
                                    path='/masters/salesdiscountallocation/details'
                                    element={<SalesDiscountAllocation />}
                                />
                                <Route
                                    path="/masters/discountdefinition"
                                    element={<DiscountDefinitionAllRecords />}
                                />
                                <Route
                                    path="/masters/discountdefinition/details"
                                    element={<DiscountDefinition />}
                                />
                                <Route
                                    path="/masters/salesdiscountallocation/details"
                                    element={<SalesDiscountAllocation />}
                                />
                                <Route
                                    path="/masters/beatfrequencyplanning"
                                    element={<BeatFrequencyPlanning />}
                                />
                                {/* <Route
                                path='/masters/segmentreactivationchangerequest'
                                element={<CreateChangeRequest />}
                            />
                            <Route
                                path='/masters/segmentreactivationchangerequestallrecords'
                                element={<SegmentReactivationAllRecords />}
                            /> */}
                                <Route
                                    path="/masters/paytermlimitupload"
                                    element={<PaytermLimitUpload />}
                                />
                                <Route
                                    path="/masters/warehousemaster"
                                    element={
                                        <WareHouseMasterProvider>
                                            <WarehouseMaster />
                                        </WareHouseMasterProvider>
                                    }
                                />

                                <Route
                                    path="/inventorymanagement/stockadjustment"
                                    element={
                                        <StockAdjustmentProvider>
                                            <StockTable />
                                        </StockAdjustmentProvider>
                                    }
                                />

                                <Route
                                    path="/masters/warehousemaster/details"
                                    element={
                                        <WareHouseMasterProvider>
                                            <WarehouseMasterNew />
                                        </WareHouseMasterProvider>
                                    }
                                />
                                <Route
                                    path="/masters/paymentaccountdefinition"
                                    element={<PaymentAccountDefinition />}
                                />
                                <Route
                                    path='/masters/segmentreactivationchangerequest'
                                    element={<CreateChangeRequest />}
                                />
                                <Route
                                    path='/masters/segmentreactivationchangerequestallrecords'
                                    element={<SegmentReactivationAllRecords />}
                                />
                                <Route path='/searchmodal' element={<SearchModal />} />
                                <Route path='/usermanagement/user' element={<User />} />
                                <Route path='/usermanagement/userdetails' element={<UserDetails />} />
                                <Route
                                    path="/usermanagement/parametersettings/master"
                                    element={<Master />}
                                />
                                <Route
                                    path="/usermanagement/parametersettings/transaction"
                                    element={<Transaction />}
                                />
                                <Route
                                    path="/usermanagement/parametersettings/tcsapplicability"
                                    element={<TCSApplicability />}
                                />
                                <Route
                                    path="/usermanagement/parametersettings/addeinvoicingitem"
                                    element={<AddEInvoicingItem />}
                                />
                                <Route
                                    path="/usermanagement/parametersettings/addpaymentUPI"
                                    element={<UserAddPaymentUPI />}
                                />
                                <Route
                                    path="/usermanagement/parametersettings/bulkinvoicingapplicability"
                                    element={<BulkInvoicingApplicability />}
                                />
                                <Route
                                    path="/usermanagement/usergroup/fieldlevelsetting"
                                    element={<FieldLevelSettings />}
                                />
                                <Route path="/usermanagement/usergroup/usergroupfield" element={<UserGroups />} />
                                <Route
                                    path="/usermanagement/usergroup/usergroupfield/details"
                                    element={<UserGroupsDetails />}
                                />
                                <Route
                                    path="/usermanagement/rewardsrebatebook"
                                    element={<RewardsRebatebook />}
                                />
                                <Route
                                    path="/usermanagement/usergroup/privilage"
                                    element={<Privilage />}
                                />
                                <Route
                                    path="/reports/sales/deliverychallantoexcel"
                                    element={<DeliveryChallanExcel />}
                                />
                                <Route
                                    path="/reports/sales/LoadingReport"
                                    element={<LoadingReport />}
                                />
                                <Route
                                    path="/reports/sales/EInvoicingDataDownload"
                                    element={<EInvoicingDataDownload />}
                                />
                                <Route
                                    path="/reports/sales/SalesPeriodicReportPDF"
                                    element={<SalesPeriodicReportPDF />}
                                />
                                <Route
                                    path="/reports/sales/invoicedatatoexcel"
                                    element={<InvoiceDataExcel />}
                                />
                                <Route
                                    path="/reports/sales/salesmonthlyreport"
                                    element={<SalesMonthly />}
                                />
                                <Route
                                    path="/reports/sales/salesperiodicreport"
                                    element={<SalesPeriodic />}
                                />
                                <Route
                                    path="/reports/sales/salesdailyreport"
                                    element={<SalesDaily />}
                                />
                                <Route
                                    path="/reports/sales/salescastrolweeklyreport"
                                    element={<SalesCastrolWeekly />}
                                />
                                <Route
                                    path="/reports/sales/salescastrolquarterlyreport"
                                    element={<SalesCastrolQuarterly />}
                                />
                                <Route
                                    path="/reports/sales/SalesComparison"
                                    element={<SalesComparison />}
                                />
                                <Route
                                    path="/reports/sales/SalesComparison"
                                    element={<SalesComparison />}
                                />
                                <Route
                                    path="/reports/sales/taxdetailsreport"
                                    element={<TaxDetails />}
                                />
                                <Route
                                    path="/reports/sales/opensalesorder"
                                    element={<OpenSalesOrder />}
                                />
                                <Route
                                    path="/reports/creditmanagementreports/receiptmadewithinperiod"
                                    element={<ReceiptMadeWithinPeriod />}
                                />
                                <Route
                                    path="/reports/purchase/GRNDiscountDatatoExcel"
                                    element={<GRNDiscountDatatoExcel />}
                                />
                                <Route
                                    path="/reports/stock/StockMonthlyDetailReport"
                                    element={<StockMonthlyDetailReport />}
                                />
                                <Route
                                    path="/reports/stock/StockCard"
                                    element={<StockCard />}
                                />
                                <Route
                                    path="/reports/stock/StockDailyDetailReport"
                                    element={<StockDailyDetailReport />}
                                />
                                <Route
                                    path="/reports/stock/StockInHandNonInventory"
                                    element={<StockInHandNonInventory />}
                                />
                                <Route
                                    path="/reports/purchase/NonInventoryGRNtoExcel"
                                    element={<NonInventoryGRNtoExcel />}
                                />
                                <Route path="/help" element={<Help />} />
                                <Route path="/helpdesk/issuelogger" element={<IssueLogger />} />
                                <Route path="/helpdesk/surveyfeedback" element={<SurveyFeedback />} />
                                <Route path="/helpdesk/surveyfeedback/view" element={<SurveyFeedbackView/>}/>
                                <Route
                                    path="/creditmanagement/documentadjustment/details"
                                    element={<Details />}
                                />
                                <Route
                                    path="/creditmanagement/documentadjustment"
                                    element={<AllRecords />}
                                />
                                <Route
                                    path="/creditmanagement/transferofunadjustedorpartiallyadjustedCNandFOC"
                                    element={<TransferofAdjustedCNandFOC />}
                                />
                                <Route path="/maintenance" element={<Maintenance />} />
                                <Route
                                    path="/reports/creditmanagementreports/customeroutstandingstatus"
                                    element={<CustomerOutstandingStatus />}
                                />
                                <Route
                                    path="/reports/creditmanagementreports/creditnoteadjustment"
                                    element={<CreditNoteAdjustment />}
                                />
                                <Route
                                    path="/reports/creditmanagementreports/customercreditnote"
                                    element={<CustomerCreditNote />}
                                />
                                <Route
                                    path="/reports/creditmanagementreports/customerdebitnote"
                                    element={<CustomerDebitNote />}
                                />
                                <Route
                                    path="/reports/creditmanagementreports/LedgerReport"
                                    element={<LedgerReport />}
                                />
                                <Route
                                    path="/reports/creditmanagementreports/StatementOfAccounts"
                                    element={<StatementOfAccounts />}
                                />
                                <Route
                                    path="/reports/creditmanagementreports/SalesAgeingReport"
                                    element={<SalesAgeingReport />}
                                />
                                <Route
                                    path="/salesmanagement/invoiceannexureprint"
                                    element={
                                        <DeliveryChallanProvider>
                                            <AnnexureAllRecords />
                                        </DeliveryChallanProvider>
                                    }
                                />
                                <Route path="/reports/pricelist" element={<PriceList />} />
                                <Route
                                    path="/reports/SchemeShortfallReports"
                                    element={<SchemeShortFall />}
                                />
                                <Route
                                    path="/creditmanagement/creditnotecreation"
                                    element={
                                        <CNCreationProvider>
                                            <AllCreationRecords />
                                        </CNCreationProvider>
                                    }
                                />
                                <Route
                                    path="/creditmanagement/pdareceiptcreation"
                                    element={<PDAReceiptCreation />}
                                />
                                <Route
                                    path="/creditmanagement/pdareceipts"
                                    element={<PDAReceipts />}
                                />
                                <Route
                                    path="/creditmanagement/writeoff"
                                    element={
                                        <WriteOffProvider>
                                            <AllWriteOffRecords />
                                        </WriteOffProvider>
                                    }
                                />
                                <Route
                                    path="/creditmanagement/writeoff/details"
                                    element={
                                        <WriteOffProvider>
                                            <WriteOffDetails />
                                        </WriteOffProvider>
                                    }
                                />
                                <Route
                                    path="/creditmanagement/writeoff/outstandingadjustment"
                                    element={
                                        <WriteOffProvider>
                                            <OutstandingAdjustment />
                                        </WriteOffProvider>
                                    }
                                />
                                <Route
                                    path="/creditmanagement/customeradvanceadjustment"
                                    element={<AdvanceAdjustmentAllRecords />}
                                />
                                <Route
                                    path="/creditmanagement/customeradvanceadjustment/details"
                                    element={<AdvanceAdjustmentDetails />}
                                />
                                <Route
                                    path="/purchasemanagement/purchasereturn"
                                    element={
                                        <PurchaseReturnProvider>
                                            <AllPurchaseReturnRecords />
                                        </PurchaseReturnProvider>
                                    }
                                />
                                <Route
                                    path='/purchasemanagement/goodsreceiptNoninventory'
                                    element={<GRNnonInv />}
                                />
                                <Route
                                    path='/purchasemanagement/goodsreceiptNoninventoryView'
                                    element={<ViewGRNnonINV />}
                                />
                                <Route
                                    path="/purchasemanagement/purchasereturn/details"
                                    element={
                                        <PurchaseReturnProvider>
                                            <PurchaseReturnDetails />
                                        </PurchaseReturnProvider>
                                    }
                                />
                                <Route
                                    path="/creditmanagement/receipts"
                                    element={
                                        <ReceiptsProvider>
                                            <AllReceiptsRecords />
                                        </ReceiptsProvider>
                                    }
                                />
                                <Route
                                    path="/creditmanagement/receipts/details"
                                    element={
                                        <ReceiptsProvider>
                                            <NewReceipt />
                                        </ReceiptsProvider>
                                    }
                                />
                                <Route
                                    path='/creditmanagement/payments'
                                    element={<PaymentAllRecords />}
                                />
                                <Route
                                    path='/creditmanagement/bankingtransactionallrecords'
                                    element={<BankingTransactionAllRecords />}
                                />
                                <Route
                                    path='/creditmanagement/bankingtransaction/details'
                                    element={<BankingTransactionDetails />}
                                />
                                <Route
                                    path='/creditmanagement/payment/details'
                                    element={<PaymentDetails />}
                                />
                                <Route
                                    path="/creditmanagement/CollectionDataDownload"
                                    element={<CollectionDataDownload />}
                                />
                                <Route
                                    path="/creditmanagement/DealerOutstandingSMS"
                                    element={<DealerOutstandingSMS />}
                                />
                                <Route
                                    path='/qrm/FreezedCNFOCReport'
                                    element={<FreezedCNFOCReport />}
                                />
                                <Route
                                    path='/qrm/CreditNoteunlockAll'
                                    element={<CreditNoteunlockAll />}
                                />  
                                <Route
                                    path='/qrm/CreditNoteunlockAddNew'
                                    element={<CreditNoteunlockAddNew />}
                                />  
                                <Route
                                    path='/qrm/FocUnlockRequestAll'
                                    element={<FocUnlockRequestAll />}
                                /> 
                                <Route
                                    path='/qrm/FocUnlockRequestAddNew'
                                    element={<FocUnlockRequestAddNew />}
                                />
                                <Route
                                    path='/fastscan/coupondisbursement'
                                    element={<CouponDisbursement />}
                                />
                                <Route
                                    path='/fastscan/CouponReporttoExcel'
                                    element={<CouponReporttoExcel />}
                                />
                                <Route
                                    path="/sgrbrand/SGRBrandDataView"
                                    element = {<SGRBrandDataView/>}
                                />
                                <Route
                                    path="/sgrbrand/SGRBrandEligibility"
                                    element = {<SGRBrandEligibility/>}
                                />
                            </Route>
                        </Route>
                    </Route>
                </Routes>
            </Suspense>
        </>
    );
}

export default App;